import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class FinYear extends EntityDto implements IEntityDto {
  FinYear_Id: string;
  FinYearName: string;
  FinYearCode: string;
  StartDate: Date;
  EndDate: Date;
  StartDateStr: string;
  EndDateStr: string;
  Company_Id: string;
  CompanyName: string; 
  TotalCount: number;
  IsActive: boolean; 
  isValidDate: boolean; 
  Start_Datestr: string|null;
End_Date: string | null;
  constructor() {
    super();
    this.FinYear_Id = '00000000-0000-0000-0000-000000000000';
    this.FinYearName = '';
    this.FinYearCode = '';
    this.Company_Id = "";
    this.CompanyName = ""; 
    this.StartDateStr = '';
    this.EndDateStr = ''; 
    this.StartDate = new Date("");
    this.EndDate = new Date("");
    this.TotalCount = 0;
    this.IsActive = true;
   this.isValidDate= false;
   this.Start_Datestr= "";
   this.End_Date="";
    this.EntityMetaData = [
      { FieldName: 'FinYearName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Financial Year is required' },
      //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
      { FieldName: 'FinYearCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
      { FieldName: 'StartDate', FieldType: FieldType.Date, IsMandatory: true, ValidationMessage: 'Start Date is required' },
      { FieldName: 'EndDate', FieldType: FieldType.Date, IsMandatory: true, ValidationMessage: 'End Date is required' },
       
    ];
  }
}